<template>
	<section 
		class="flex justify-center items-center"
		:class="computedClass"
	>
		<div 
			class="loader rounded-full border-4 border-grey-50"
			:class="computeddiameter"
			:style="spinnerSpeed + spinnerColor"
		></div>
	</section>
</template>

<script>
// Shared loading indicator for listing, property, and detail loading states.
export default {
	props: {
		small: { type: Boolean, default: false },
		diameter: { type: [String, Number], default: '' },
		speed: { type: [String, Number], default: 2 },
		color: { type: String, default: '#6585a3' },
		size: { type: String, default: '' },
	},
	computed: {
		computedClass: function() {
			if (this.small) {
				return ''
			} else if (this.size) {
				return this.size
			} else {
				return 'w-full h-screen'
			}
		},
		computeddiameter: function() {
			if (this.diameter) {
				return 'w-'+this.diameter+' h-'+this.diameter
			} else {
				return 'w-80 h-80'
			}
		},
		spinnerSpeed: function() {
			return `animation: spin ${this.speed}s linear infinite; `
		},
		spinnerColor: function() {
			return `border-top: solid ${this.color};`
		}

	},
}
</script>
